<template>
  <div class="member-card" :class="{ 'is-pending': isPending, 'is-self': isSelf }" @click="handleClick">
    <div class="card-header">
      <div class="member-info">
        <h4 class="member-name">{{ member.ptName }}</h4>
        <span class="relationship-badge">
          {{ member.relationship }}
        </span>
      </div>

      <div class="authorization-status" v-if="!isSelf">
        <span class="status-badge" :class="statusClass">
          {{ statusText }}
        </span>
      </div>
    </div>

    <div class="card-body" v-if="showDetails">
      <div class="info-row">
        <span class="label">身分證字號</span>
        <span class="value">{{ member.ptIdno }}</span>
      </div>
      <div class="info-row">
        <span class="label">生日</span>
        <span class="value">{{ member.ptBirthday }}</span>
      </div>
    </div>

    <div class="card-footer" v-if="showActions">
      <button
        class="btn btn-sm btn-outline-primary"
        @click.stop="$emit('edit', member)"
      >
        編輯
      </button>
      <button
        class="btn btn-sm btn-outline-danger"
        @click.stop="$emit('delete', member)"
      >
        刪除
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MemberCard',
  props: {
    member: {
      type: Object,
      required: true,
    },
    isSelf: {
      type: Boolean,
      default: false,
    },
    showDetails: {
      type: Boolean,
      default: false,
    },
    showActions: {
      type: Boolean,
      default: true,
    },
    // 由 parent 傳入，SAW API 用 auth / family array 區分授權狀態
    isAuthorized: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isPending() {
      return !this.isAuthorized
    },

    statusClass() {
      return this.isPending ? 'status-unauthorized' : 'status-authorized'
    },

    statusText() {
      return this.isPending ? '未授權' : '已授權'
    },
  },
  methods: {
    handleClick() {
      if (!this.isPending) {
        this.$emit('click', this.member)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.member-card {
  background: white;
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 16px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover:not(.is-pending) {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
  }

  &.is-pending {
    opacity: 0.6;
    border-color: #f59e0b;
    cursor: not-allowed;
  }

  &.is-self {
    border-color: #207868;
  }

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;

    .member-info {
      flex: 1;

      .member-name {
        font-size: 20px;
        font-weight: bold;
        color: #333;
        margin: 0 0 8px 0;
      }

      .relationship-badge {
        display: inline-block;
        background: #207868;
        color: white;
        padding: 4px 12px;
        border-radius: 16px;
        font-size: 12px;
        font-weight: 600;
      }
    }

    .authorization-status {
      .status-badge {
        display: inline-block;
        padding: 6px 16px;
        border-radius: 12px;
        font-size: 12px;
        font-weight: bold;

        &.status-authorized {
          background: #e8f5f3;
          color: #207868;
        }

        &.status-unauthorized {
          background: #fef3e8;
          color: #f59e0b;
        }
      }
    }
  }

  .card-body {
    margin-bottom: 12px;

    .info-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 8px 0;
      border-bottom: 1px solid #f0f0f0;

      &:last-child {
        border-bottom: none;
      }

      .label {
        font-size: 14px;
        color: #666;
        font-weight: 500;
      }

      .value {
        font-size: 14px;
        color: #333;
        font-weight: 600;
      }
    }
  }

  .card-footer {
    display: flex;
    gap: 8px;
    justify-content: flex-end;
    padding-top: 12px;
    border-top: 1px solid #f0f0f0;

    .btn {
      padding: 6px 16px;
      font-size: 14px;
      border-radius: 8px;
      font-weight: 600;
      transition: all 0.2s;

      &.btn-outline-primary {
        border: 1px solid #207868;
        color: #207868;
        background: white;

        &:hover {
          background: #207868;
          color: white;
        }
      }

      &.btn-outline-danger {
        border: 1px solid #dc3545;
        color: #dc3545;
        background: white;

        &:hover {
          background: #dc3545;
          color: white;
        }
      }
    }
  }
}
</style>
